<script setup lang="ts">
const emit = defineEmits<{
  (e: 'close'): void
}>()

const { t } = useI18n()
const { ecommerce } = useAnalytics()

const activeOrderStore = useActiveOrderStore()
const uiStore = useUiStore()
const totalQuantity = computed(() => activeOrderStore.activeOrder.data?.totalQuantity ?? 0)

function handleCartClick() {
  emit('close')
  uiStore.openCartDrawer()
  ecommerce.viewCart()
}
</script>

<template>
  <header class="sticky top-0 z2 h16 flex shrink-0 bg-background shadow">
    <div class="hfull flex grow-1 items-center justify-between of-hidden pl4 space-x-2">
      <button
        data-testid="offCanvasToCart"
        class="h12 flex grow-1 flex-col items-center justify-center rd-1 bg-slate-100 p0"
        @click="handleCartClick"
      >
        <span class="flex items-center justify-center">
          <span class="relative top-0 box-border">
            <Icon name="i-heroicons:shopping-bag" class="text-xl" />
          </span>
          <span v-if="totalQuantity > 0" class="ml0.5 text-2.5 fw700">
            {{ totalQuantity }}
          </span>
        </span>
        <span class="max-w-[15ch] of-hidden text-ellipsis text-xs fw-bold">
          {{ t('cart.label') }}
        </span>
      </button>
    </div>

    <div class="flex items-center justify-center">
      <UiButton
        data-testid="drawerCloseIcon"
        variant="ghost"
        size="icon"
        @click="emit('close')"
      >
        <Icon name="i-heroicons:x-mark" class="text-lg" />
      </UiButton>
    </div>
  </header>
</template>
